import { IS_SSR } from './client-only'
import { doNothing } from './do-nothing'

let isPassiveSupported = false

if (!IS_SSR) {
  try {
    const options = Object.defineProperty({}, 'passive', {
      get() {
        isPassiveSupported = true
        window.removeEventListener('test', doNothing, options)
        return undefined
      },
    })

    window.addEventListener('test', doNothing, options)
  } catch {
    // we do not need to throw here
  }
}

export { isPassiveSupported }
